import { defineMessages } from 'react-intl';

export default defineMessages({
	heading: {
		id: 'subpage.mindfulness.unlock.heading',
		defaultMessage: 'Get the relaxation you deserve.',
		description: 'Heading for the mindfulness category page unlock section',
	},
	body: {
		id: 'subpage.mindfulness.unlock.body',
		defaultMessage: 'Choose from an extensive catalog, from 2-minute breathing exercises to 7-day programs.',
		description: 'Body text for the mindfulness category page unlock section',
	},
});
